<div fxLayout="column" class="full-width">
  <div fxLayout="row" class="pipeline-search-header">
    <div fxLayout="column" fxLayoutAlign="space-between center">
      <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px" class="pt-1">
        <button (click)="responsiveDrawer.closeDrawer()" mat-icon-button>
          <mat-icon svgIcon="back-arrow-button" style="transform: rotate(180deg)"></mat-icon>
        </button>
        <div class="heading-bold">Lease Details</div>
      </div>
    </div>
  </div>
  <hr/>
  @if (leaseData) {
    <app-lease-view [data]="leaseData" (updateLeaseStatus)="updateLeaseStatus.emit()"></app-lease-view>
  }
</div>
